import type { LanguageCode, LegalLanguages } from '../types';

export function getEffectiveLegalLanguagesFromConfig(
  country: string,
  legalLanguages: LegalLanguages,
  userLanguage: LanguageCode,
): {
  preferredByUser: LanguageCode;
  default: LanguageCode;
  configuredOptions: Array<LanguageCode>;
} {
  const legalLanguage = legalLanguages[country.toLowerCase()] || legalLanguages['default'];

  if (typeof legalLanguage === 'object') {
    const configuredOptions = Object.entries(legalLanguage)
      .filter(([key]) => key !== 'default')
      .map(([, value]) => value);

    return {
      preferredByUser: legalLanguage[userLanguage] || legalLanguage['default'] || '',
      default: legalLanguage['default'] || '',
      configuredOptions,
    };
  }

  return {
    preferredByUser: legalLanguage || '',
    default: legalLanguage || '',
    configuredOptions: legalLanguage ? [legalLanguage] : [],
  };
}

export function getLegalLanguageFromConfig(
  country: string,
  legalLanguages: LegalLanguages,
  userLanguage: LanguageCode,
): LanguageCode {
  const legalLanguage = legalLanguages[country.toLowerCase()] || legalLanguages['default'];

  if (typeof legalLanguage === 'object') {
    return legalLanguage[userLanguage] || legalLanguage['default'] || '';
  }

  return legalLanguage || '';
}
